import { useRef, useState } from "react";
import { Download, Share2, Pause, Play } from "lucide-react";
import { toast } from "sonner";

export const SongSection = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    const a = audioRef.current;
    if (!a) return;
    if (a.paused) { a.play(); setPlaying(true); }
    else { a.pause(); setPlaying(false); }
  };

  const handleShare = async () => {
    const shareData = {
      title: "Together We Grow — Ward 3",
      text: "Listen to the official Together We Grow song. Vote for Si — Sikaiadah Newton for City Council Ward 3.",
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        toast.success("Link copied to clipboard");
      }
    } catch (e) {
      // user cancelled or failed
    }
  };

  return (
    <section
      id="song"
      data-testid="song-section"
      className="relative bg-royal py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Image */}
          <div className="lg:col-span-7">
            <div className="relative rounded-sm overflow-hidden border border-white/10">
              <img
                src="/assets/group.png"
                alt="Together We Grow Ward 3"
                className="w-full h-auto object-cover"
              />
              <button
                onClick={togglePlay}
                data-testid="song-play-toggle"
                className="absolute top-5 right-5 h-14 w-14 rounded-full bg-lavender text-royal-deep flex items-center justify-center hover:scale-105 transition-transform"
                aria-label={playing ? "Pause" : "Play"}
              >
                {playing ? <Pause size={22} fill="currentColor" /> : <Play size={22} className="ml-0.5" fill="currentColor" />}
              </button>
            </div>

            <audio
              ref={audioRef}
              src="/assets/together-we-grow.mp3"
              onEnded={() => setPlaying(false)}
              preload="metadata"
              data-testid="song-audio"
            />
          </div>

          {/* Right copy */}
          <div className="lg:col-span-5">
            <p className="text-[11px] tracking-[0.32em] uppercase text-classy-soft mb-4">
              02 — The campaign anthem
            </p>
            <h2
              data-testid="song-heading"
              className="font-serif-display text-classy text-5xl sm:text-6xl lg:text-7xl leading-[0.95] font-medium mb-6"
            >
              Together <span className="italic font-light">We</span> Grow
              <br />
              <span className="text-2xl sm:text-3xl lg:text-4xl tracking-[0.18em] uppercase block mt-3 font-sans font-light">
                The Song
              </span>
            </h2>

            <p className="text-classy-soft/85 leading-relaxed mb-8 text-[15px]">
              A movement deserves its own anthem. Press play, download it and share it. Let every resident in Ward 3 hear that <em>Community Is Our Power.</em>
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/assets/together-we-grow.mp3"
                download="Together-We-Grow-Ward3.mp3"
                data-testid="song-download-btn"
                onClick={() => toast.success("Download started")}
                className="btn-classy px-7 py-4 rounded-full text-xs uppercase inline-flex items-center justify-center gap-2"
              >
                <Download size={16} /> Download the Song
              </a>
              <button
                onClick={handleShare}
                data-testid="song-share-btn"
                className="btn-outline-classy px-7 py-4 rounded-full text-xs uppercase inline-flex items-center justify-center gap-2"
              >
                <Share2 size={16} /> Share the Song
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SongSection;
